<template>
  <v-card class="ts-record-table">
    <v-data-table
        ref="table"
        v-model="selectedRecords"
        v-bind="$attrs"
        :dense="$mq === 'mobile'"
        :items="sortedRecords.filter(({deleted}) =>!deleted)"
        :headers="headers"
        :show-select="selectable"
        sort-by="key"
        mobile-breakpoint="0"
        :item-key="editable ? 'key' : 'record_id'"
        :items-per-page="itemsPerPage"
        :item-class="(item) => (['ts-record-table__item',item.saved && 'ts-record-table__item--has-date'])"
        @update:items-per-page="val =>$emit('update:items-per-page',val)"
        @input="payload => $emit('input', payload)"
    >
      <template v-if="!hideTitle" v-slot:top>
        <v-card-title>
          <slot name="title"><span>{{title || '최근 전적'}}</span></slot>
          <slot name="title.append"></slot>
          <v-spacer></v-spacer>
          <v-btn v-if="isEditable && $mq !== 'mobile'" tile color="error" @click="handleClickDelete">
            <v-tooltip bottom>
              삭제시 백업
              <template v-slot:activator="{on}">
                <input type="checkbox" v-model="saveAtDeleting" v-on="on" @click.stop/>
              </template>
            </v-tooltip>
            삭제
          </v-btn>
          <v-btn v-if="isEditable" tile color="primary" @click="handleClickSave">저장</v-btn>
        </v-card-title>
      </template>
      <!-- columns -->
      <template v-slot:item.idx = "{item, value}">
        <span @click="resetScore(item)">
          {{value- -1}}
        </span>
      </template>
      <template v-slot:item.date = "{item, value}">
        <v-btn icon v-if="forTeaming" :color="item.saved ? 'error' : ''" @click="openOptionDialog(item)"><v-icon>mdi-menu</v-icon></v-btn>
        <v-btn v-else x-small color="error">
          <span>{{value | dateTrim(5,11)}}</span>
        </v-btn>
      </template>
      <template v-slot:item.type = "{item}">
        <ts-player v-if="item.boksik" color="error">복</ts-player>
        <ts-player v-else color="success">단</ts-player>
      </template>
      <template v-slot:item.winners = "{item, value}">
        <v-btn text @click="item.isEditableRecord || handleClickTeam(value,item.losers)">
          <ts-player
              v-for="(_p,i) in value" :key="i"
              :player="getPlayer(_p)"
              @click="item.isEditableRecord && selectPlayer(item, value, i)"
          />
          <ts-player v-if="item.isEditableRecord && (!value || value.length < 2)" @click="selectPlayer(item, value)">Add</ts-player>
        </v-btn>
      </template>
      <template v-slot:item.result = "{item}">
        <div class="ts-record-table__result-wrapper text-center">
          <span
              class="ts-record-table__result"
              @click="() => {if(!item.saved) {item.result[0]++;$forceUpdate();handleResultChange(item)}}"
          >{{ item.result[0] }}</span>
          <span>:</span>
          <span
              class="ts-record-table__result"
              @click="() => {if(!item.saved) {item.result[1]++;$forceUpdate();handleResultChange(item)}}"
          >{{ item.result[1] }}</span>
        </div>
      </template>
      <template v-slot:item.losers = "{item, value}">
        <v-btn text @click="item.isEditableRecord || handleClickTeam(value,item.winners)">
          <ts-player
              v-for="(_p,i) in value" :key="i"
              :player="getPlayer(_p)"
              @click="item.isEditableRecord && selectPlayer(item, value, i)"
          />
          <ts-player v-if="item.isEditableRecord && (!value || value.length < 2)" @click="selectPlayer(item, value)">Add</ts-player>
        </v-btn>
      </template>

      <!-- addrow -->
      <template v-if="forTeaming" v-slot:body.append>
        <tr>
          <td :colspan="headers.length+ (selectable ? 1 : 0)">
            <v-row justify="center" no-gutters>
              <v-btn tile @click="appendRecord" width="100%" color="warning">추가</v-btn>
            </v-row>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="visiblePlayerSelectDialog">
      <v-row v-if="playerSelect.target && playerSelect.item" class="white" justify="center" no-gutters>
        <ts-player
            v-for="(player,i) in players" :key="i" big
            :player="player"
            @click="replaceSelectPlayer(player)"
            v-show="!(playerSelect.item.winners.includes(player.name) || playerSelect.item.losers.includes(player.name))"
        />
      </v-row>
    </v-dialog>

    <!-- option dialog -->
    <v-dialog v-model="optionDialog.visible">
      <v-card class="pa-3">
        <v-row no-gutters>
          <ts-player
              v-for="(_p,i) in optionItem.winners" :key="`w-${i}`"
              :player="getPlayer(_p)"
          />
          {{(optionItem.result || []).join(':')}}
          <ts-player
              v-for="(_p,i) in optionItem.losers" :key="`l-${i}`"
              :player="getPlayer(_p)"
          />
        </v-row>
        <v-row no-gutters v-if="optionItem.saved">{{optionItem.date}} 에 저장됨</v-row>
        <v-row no-gutters>
          <v-btn @click="resetScore(optionItem, optionDialog.visible = false)" :disabled="optionItem.saved">점수초기화</v-btn>
          <v-btn @click="deleteItem(optionItem, () => {$emit('click:delete');optionDialog.visible = false})" color="error">삭제</v-btn>
        </v-row>

      </v-card>
    </v-dialog>

    <!-- relative rankingCard -->
    <v-dialog v-model="dialogRelative">
      <v-row no-gutters style="background-color: white;height:50px;">
        <v-spacer></v-spacer>
        <v-col cols="auto">
          <v-btn icon @click="dialogRelative=false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col>
          <ts-ranking-card
              :players="players"
              :records="totalRecord"
              :record-filter="(r)=>(isSameTeam(selectedTeam,r.winners) || isSameTeam(selectedTeam,r.losers))"
              :team="selectedTeam && selectedTeam.length > 1"
              :relative-team="selectedTeam"
              :highlight-team="oppositeTeam"
              :min-total="1"
          >
            <template v-slot:title>{{selectedTeam.join('')}} 의 상대전적</template>
          </ts-ranking-card>
        </v-col>
      </v-row>
    </v-dialog>
  </v-card>
</template>

<script>
  import TsPlayer from "@/components/TsPlayer";
  import { downloadAsFile } from "@/util/nativeHelper";
  import TsRankingCard from "@/components/TsRankingCard";
  import { getRecords } from "@/api/record";
  import RecordUtil from "@/util/recordUtil";

  export default {
    name: "TsRecordTable",
    components: {TsRankingCard, TsPlayer},
    mixins: [RecordUtil],
    props: {
      selectable: Boolean,
      winnerAlwaysLeft: Boolean,
      forTeaming: Boolean,
      editable: Boolean,
      title: String,
      players: Array,
      records: {
        type: Array,
        default: () => ([])
      },
      hideTitle:Boolean,
      sort: {
        type: [String,Boolean],
        default: 'desc'
      },
      itemsPerPage: {
        type: [Number,String],
        default: 5
      },
    },
    data() {
      return {
        optionDialog: {
          item: null,
          visible: false
        },
        saveAtDeleting: true,

        selectedRecords: [],

        selectedTeam: [],
        oppositeTeam: [],
        totalRecord: [],
        dialogRelative: false,

        headers: [
          {value: 'idx', text:'#', width:'25px', align:'center'},
          ...this.forTeaming ? [] :[{value: 'type', text: '구분', align:'center'}],
          {value: 'winners', text: this.forTeaming ? '팀1' : '승리', align:'center'},
          {value: 'result', text: '결과', align:'center'},
          {value: 'losers', text: this.forTeaming ? '팀2' : '패배', align:'center'},
          {value: 'date', text: this.forTeaming ? '옵션' : '일자', align:'center'}
        ],

        visiblePlayerSelectDialog: false,
        playerSelect: {
          target:null,
          item:null
        },
      }
    },
    filters: {
      dateTrim (val, from = 0, length = 16) {
        return val && val.substr(from, length)
      },
    },
    computed: {
      optionItem() {
        return this.optionDialog.item || {}
      },
      isEditable() {
        return this.editable
      },
      sortedRecords () {
        // record initialize 여기가 중요
        const records = this.records.map((r,i) => ({
          result: [0,0],
          editing: false,
          ...r,
          idx: i,
          saved: !!r.date
        }))
        if(this.sort)
          records.sort((a, b) => `${b.date}`.localeCompare(`${a.date}`) * (this.sort === 'asc' ? -1 : 1))
        if(this.winnerAlwaysLeft)
          records.forEach(r => {
            if( r.result[1] > r.result[0]){
              r.losers.splice(0,r.losers.length,...r.winners.splice(0,r.winners.length,...r.losers))
              r.result.push(...r.result.splice(0, 1))
            }
          })
        return records
      },
      playerObject () {
        return Object.fromEntries((this.players || []).map(player => ([player.name,player])))
      }
    },
    mounted() {
      getRecords().then(data => (this.totalRecord = data))
    },
    methods: {
      openOptionDialog(item){
        this.optionDialog.item = item
        this.optionDialog.visible = true
      },
      resetScore(item) {
        if (!item.saved) {
          item.result[0] = 0;
          item.result[1] = 0;
          this.$forceUpdate();
          this.handleResultChange(item)
        }
      },
      replaceSelectPlayer(player){
        const idx = this.playerSelect.idx >= 0 ? this.playerSelect.idx : this.playerSelect.target.length || 0
        this.playerSelect.target[idx] = player.name
        if(this.playerSelect.idx >= 0)
          this.visiblePlayerSelectDialog = false
        else
          this.playerSelect.idx = idx- -1
        this.$forceUpdate()
      },
      selectPlayer(item, value, i){
        this.playerSelect.item = item
        this.playerSelect.target = value
        this.playerSelect.idx = i
        this.visiblePlayerSelectDialog = true
      },
      appendRecord(){
        this.updateRecords(this.sortedRecords.concat({
          boksik: true,
          isEditableRecord: true,
          result: [0,0],
          editing: false,
          winners: [],
          losers: []
        }))
      },

      async deleteItem(item, callBack){
        item = Array.isArray(item) ? item : [item]
        if(!await this.$confirm(`${item.map(({idx})=> idx - -1)} 번째 매칭을 삭제합니다?`)) return
        const keyList = item.map(({key})=> key)
        const newRecords = this.sortedRecords.map((_item) => {
          if (keyList.includes(_item.key)) _item.deleted = true
          return _item
        })
        this.updateRecords(newRecords)
        callBack && callBack()
      },
      updateRecords(records){
        this.$emit('update:records',records || this.sortedRecords)
      },
      handleClickTeam(v, oppositeSide){
        this.selectedTeam = v;
        this.oppositeTeam = oppositeSide;
        this.dialogRelative=true
        this.$emit('click:team', v, oppositeSide)
      },
      async handleClickDelete(){
        const deleteTarget = Object.values(this.$refs.table.selection)
        if(!deleteTarget.length && !await this.$confirm('위험해요!!','데이터전부삭제','error')) return

        if(this.saveAtDeleting){
          const savedRecords = this.sortedRecords.filter(r => r.saved)
          if(savedRecords.length) downloadAsFile(JSON.stringify(savedRecords),`dataBackup_${this.$day().dateFormat()}.json`)
        }
        if(deleteTarget.length) await this.deleteItem(deleteTarget)
        else this.updateRecords([])
        this.$emit('click:delete')
      },
      handleClickSave(){
        this.updateRecords(this.sortedRecords.map((r) => {
            if(r.editing && !r.date && r.result[0] !== r.result[1]) r.date = this.$day().dateTimeFormat()
            delete r.editing
            return r
          }
        ))
        this.$emit('click:save')
      },
      handleResultChange(item){
        this.sortedRecords[item.idx].editing = true
        if(item.winners.length <= 0 || item.winners.length > 2) return this.$alert('인원이 적절하지 않습니다.')
        if(item.winners.length !== item.losers.length) return this.$alert('상대수가 같지않습니다')
        this.updateRecords(this.sortedRecords.map((r,i) => {
              r.boksik = r.winners.length % 2 === 0
              r.key || (r.key = new Date().getTime()+'-'+i)
              delete r.isEditableRecord
              return r
            }
        ))
        // this.$emit('click:save')
      },
      getPlayer(_p){
        return typeof _p === 'string' ? this.playerObject[_p] : _p
      }
    }
  }
</script>


<style scoped lang="scss">
::v-deep .v-dialog{
  height:auto;
}
</style>

<style lang="scss">
.mobile{
  .ts-record-table{
    .v-chip{
      padding: 5px;
    }
  }
}
.ts-record-table {
  background-color: transparent !important;
  .v-btn{
    padding:0 !important;
  }
  td, th{
    padding: 0 !important;
  }
  .v-data-table{
    background-color: rgba(255,255,255,0.5) !important;
  }

  .v-data-table__mobile-row{
    .ts-record-table__result-wrapper{
      min-width: 230px;
    }
  }

  .v-card-title{
    flex-wrap:nowrap;
  }

  &__wrapper {
    overflow-y: auto;
  }
  &__result-wrapper{
    font-size: 20px;
    display:flex;
    align-items:center;
    justify-content: center;
    .ts-record-table__result{
      font-size:24px;
      width:48px;
      background-color: #bbbbbb;
      cursor: pointer;
    }
  }
}
</style>